<h1>This is public content</h1>
<p>No auth is required to view this page. Any user can navigate directly here.</p>
<img class="hero-image" src="/gkn-animation.gif" width="700" height="auto" />
